<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.5 11L23.5 11" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.5 13.5C14.6716 13.5 14 14.1716 14 15V20C14 20.8284 14.6716 21.5 15.5 21.5H16.5C17.3284 21.5 18 20.8284 18 20V15C18 14.1716 17.3284 13.5 16.5 13.5H15.5Z" fill="currentColor"/>
</svg>
